import { t } from 'i18next'
import * as z from 'zod'

import { LoginFormVO } from './type'

// MEMO: ログイン情報なので敢えてフロントではvalidationをかけない
export const schema = z.object({
  userId: z.string().min(1, t('auth.validation.required')),
  password: z.string().min(1, t('auth.validation.required')),
  storeCode: z.string().min(1, t('auth.validation.required')),
  saveStoreCode: z.boolean(),
})

export const formLabels: Record<keyof LoginFormVO, string> = {
  userId: t('auth.login.userId'),
  password: t('auth.login.password'),
  storeCode: t('auth.login.storeCode'),
  saveStoreCode: t('auth.login.saveStoreCode'),
}

export const defaultValues: LoginFormVO = {
  userId: '',
  password: '',
  storeCode: '',
  saveStoreCode: false,
}
